
import React from 'react';
import { Play, Pause } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '../../contexts/language';
import { Region } from '../../data/types/region-types';
import YouTubeEmbed from '../video/YouTubeEmbed';

interface RegionVideoProps {
  region: Region;
}

const RegionVideo: React.FC<RegionVideoProps> = ({ region }) => {
  const { t } = useLanguage();
  const [isPlaying, setIsPlaying] = React.useState(false);
  
  // For Chiapas and Hidalgo, use YouTube videos, for others use local MP4
  if (region.region_id === 'CHIS') {
    return (
      <div className="space-y-4 mb-6">
        <h3 className="text-lg font-semibold">{t('aboutRegion')}</h3>
        <YouTubeEmbed 
          videoId="hCQIokJhsys" 
          title="About Chiapas Region"
        />
      </div>
    );
  }

  if (region.region_id === 'HGO') {
    return (
      <div className="space-y-4 mb-6">
        <h3 className="text-lg font-semibold">{t('aboutRegion')}</h3>
        <YouTubeEmbed 
          videoId="Hju951EsdQQ" 
          title="About Hidalgo Region"
        />
      </div>
    );
  }
  
  // Video sources for other regions
  const videoSource = '/videos/region-overview.mp4';
    
  const handlePlayPause = () => {
    const video = document.getElementById('region-video') as HTMLVideoElement;
    if (video) {
      if (isPlaying) {
        video.pause();
      } else {
        video.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="space-y-4 mb-6">
      <h3 className="text-lg font-semibold">{t('aboutRegion')}</h3>
      <div className="relative rounded-lg overflow-hidden bg-gray-100">
        <video
          id="region-video"
          className="w-full aspect-video object-cover"
          src={videoSource}
          onEnded={() => setIsPlaying(false)}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <Button
            variant="secondary"
            size="icon"
            className="bg-white/90 hover:bg-white shadow-lg"
            onClick={handlePlayPause}
          >
            {isPlaying ? (
              <Pause className="h-6 w-6" />
            ) : (
              <Play className="h-6 w-6" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RegionVideo;

